{
  "pagination": {
    "ListSlackChannelConfigurations": {
      "input_token": "nextToken",
      "output_token": "nextToken"
    },
    "ListSlackWorkspaceConfigurations": {
      "input_token": "nextToken",
      "output_token": "nextToken"
    }
  }
}
